import { NotificationType } from '@vista-digital/occ-domain';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
export function getFailedToAddFilmNotificationDetails(film, displayText, i18n) {
    const formattedMessage = i18n.template(displayText.failedToAddFilmToWatchlistMessage, {
        filmTitle: i18n.translatable(film.title)
    });
    return {
        id: getIdForComponentNotification('film-watchlist-button', NotificationType.Error, 'failed-to-add-film'),
        title: displayText.failedToAddFilmToWatchlistTitle,
        messages: [formattedMessage]
    };
}
export function getFailedToRemoveFilmNotificationDetails(film, displayText, i18n) {
    const formattedMessage = i18n.template(displayText.failedToRemoveFilmFromWatchlistMessage, {
        filmTitle: i18n.translatable(film.title)
    });
    return {
        id: getIdForComponentNotification('film-watchlist-button', NotificationType.Error, 'failed-to-remove-film'),
        title: displayText.failedToRemoveFilmFromWatchlistTitle,
        messages: [formattedMessage]
    };
}
//# sourceMappingURL=notifications.js.map